import React from 'react';
import * as S from './SearchResultPage.styles';
import SRP from './../../containers/SRP/SRP';

const SearchResultPage = () => {
  return (
    <S.SeachResultPageWrapper>
      <SRP></SRP>
    </S.SeachResultPageWrapper>
  );
};

export default SearchResultPage;
